module.exports = __webpack_public_path__ + "static/img/demo-image-01.0b91257.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demo-image-01.png
// module id = ITa7
// module chunks = 1